import React from 'react';
import useForm from '~/app/modules/form/useForm';
import { IssueClosePayload } from '~/types';
import classes from './style.module.scss';
import MForm from '~/app/modules/form';
import Textarea from '~/app/modules/form/Textarea';
import useTranslation from '~/app/hooks/useTranslation';
import { useWorkOrderHPCodes, useWorkTypes } from '~/app/data/statuses/issue';
import { useStoreState } from '~/store';
import WorkHoursInput from '~/app/modules/form/WorkHoursInput';
import Select from '~/app/modules/form/Select';

export type DetailsComponent = React.FC;

const Details: DetailsComponent = () => {
  const { t } = useTranslation('issue');
  const { values: formValues, fieldEvents: formFieldEvents } = useForm<IssueClosePayload>({ formName: 'completeIssue' });
  const issueDetails = useStoreState(state => state.issue.data);

  const workTypes = useStoreState(state => state.issue.workTypes);
  const workorderTypes = useWorkTypes(workTypes);

  const HPCodes = useStoreState(state => state.issue.HPCodes);
  const issueHpCodes = useWorkOrderHPCodes(HPCodes);
  const isHPCodeRequired = useStoreState(state => state.issue.isHPCodeRequired);

  const costCategories = useStoreState(state => state.issue.costCategories);
  const selectedCategory = costCategories.find(({ id }) => Number(id) === Number(issueDetails?.costCategoryId));

  const overtime1Percentage = issueDetails?.workOrderCost?.overtime1Percentage ?? selectedCategory?.costData?.overtime1Percentage;
  const overtime2Percentage = issueDetails?.workOrderCost?.overtime2Percentage ?? selectedCategory?.costData?.overtime2Percentage;

  return (
    <>
      <MForm className={`${classes['form']} ${classes['details']}`}>
        <div className={classes['issue-complete']}>
          <Textarea
            className={`${classes['input-container']}`}
            placeholder={t('issueClose.comment.placeholder')}
            descriptionPosition="top"
            name="comment"
            defaultValue={formValues.comment}
            {...formFieldEvents}
          />
          {isHPCodeRequired && <Select
            className={`${classes['input-container']}`}
            name="hpCode"
            placeholder={t('hpCode.placeholder')}
            options={issueHpCodes}
            icon={'keyboard_arrow_down'}
            onChange={formFieldEvents.onChange}
            defaultValue={formValues.hpCode}
            showEmptyOption={true}
            emptyOptionValue={0}
          />}
          <WorkHoursInput
            placeholder={t('ordinaryHours.placeholder')}
            name="ordinaryHours"
            defaultValue={formValues.ordinaryHours}
            {...formFieldEvents}
          />
          <WorkHoursInput
            placeholder={overtime1Percentage
              ? t('overTime50.placeholder', { overTime50: overtime1Percentage })
              : t('overTime50.defaultPlaceholder')
            }
            name="overTime50"
            defaultValue={formValues.overTime50}
            {...formFieldEvents}
          />
          <WorkHoursInput
            placeholder={overtime2Percentage
              ? t('overTime100.placeholder', { overTime100: overtime2Percentage })
              : t('overTime100.defaultPlaceholder')
            }
            name="overTime100"
            defaultValue={formValues.overTime100}
            {...formFieldEvents}
          />
          <Select
            className={`${classes['input-container']}`}
            name="workType"
            placeholder={t('workType.placeholder')}
            options={workorderTypes}
            icon={'keyboard_arrow_down'}
            onChange={formFieldEvents.onChange}
            defaultValue={formValues.workType}
            showEmptyOption={true}
            emptyOptionValue={0}
          />
        </div>
      </MForm>
    </>
  );
};

export default Details;
